import(/* webpackMode: "eager" */ "/app/app/globals.css");
import(/* webpackMode: "eager" */ "/app/components/ui/sonner.tsx");
import(/* webpackMode: "eager" */ "/app/context/AuthProvider.tsx");
import(/* webpackMode: "eager" */ "/app/context/ReactQueryClientProvider.tsx");
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
import(/* webpackMode: "eager" */ "/app/redux/Provider.tsx")